import React from 'react';

import { ErrorModal } from '~/components/error';
import { useIntl } from '~/contexts/intl';
import { NetworkServiceReachability } from '~/contexts/network-service-state';
import { generateErrorId } from '~/error/app-error-boundary';
import * as ErrorDiagnostics from '~/error/app-error-diagnostics';

import { BannerNotification } from '../banner-notification';

export type NetworkServiceNotificationProps = { reachability?: NetworkServiceReachability; latency?: number };

export function NetworkServiceNotification(props: NetworkServiceNotificationProps) {
    const { reachability, latency } = props;

    const { formatMessage } = useIntl();

    let message = formatMessage('network-state.poor-connection');

    if (__DEV__ && latency) {
        message += ` - ${Math.round(latency)} ms`;
    }

    // Generate error ID and log to Sentry when service is unavailable???
    const connectionError = reachability === 'service-unavailable' ? new Error('Network service unavailable') : null;
    const errorId = connectionError ? generateErrorId() : null;

    if (connectionError && errorId) {
        ErrorDiagnostics.error(connectionError, {
            errorUuid: errorId,
            component: 'network-service-notification',
            reachability: reachability ?? null,
            latency: latency ? Math.round(latency) : null
        });
    }

    return (
        <>
            {reachability === 'service-unavailable' && connectionError && (
                <ErrorModal id={errorId!} error={connectionError} errorType="connection" />
            )}
            {reachability === 'service-degraded' && <BannerNotification type="warning" text={message} />}
        </>
    );
}
